import {
  EventPingActivityTypeEnum,
  FormPublic,
  IntegrationEnum,
  NotifyTo,
  RequestTypeEnum,
  StudioIntegrationTemplate,
  WorkspaceBasicInfo
} from '@goldcast/api/backend';

import { ScheduledEmail } from '@/studio/emailSchedule/store/types';
import { ActivityTypesEnum } from '@/studio/eventIntegration/store/types';
import {
  FieldMappingBooleans,
  FieldMappingRowErrors,
  FieldMappings,
  PrevFieldMappings,
  SourceField
} from '@/studio/orgIntegration/store/types';
import { ThemeObj } from '@/studio/studioEventList/store/types';

export interface State {
  searchTerm: string;
  currentTemplateId: string;
  templates: Templates;
  sortBy: SortBy;
  filterBy: FilterBy;
  isLoading: boolean;
  currentPage: number;
  templatesPerPage: number;
  templatesCount: number;
  isEmailTemplateLoading: boolean;
  registrationEmail: ScheduledEmail | null;
  currentIntegrationTemplate: StudioIntegrationTemplate | null;
  isIntegrationTemplateLoading: boolean;
  isIntegrationTemplateUpdating: boolean;
  isTemplateNotificationsLoading: boolean;
  templateNotifications: TemplateNotification[];
  isTemplateWebhooksLoading: boolean;
  templateWebhooks: TemplateWebhook[];
  templateSourceFields: SourceField[];
  isTemplateSourceFieldLoading: boolean;
  templateFieldMappings: FieldMappings;
  prevTemplateFieldMappings: PrevFieldMappings;
  templateFieldMappingRowError: FieldMappingRowErrors;
  isSaveTemplateFieldMappingLoading: FieldMappingBooleans;
}

export interface Template {
  id: string;
  created_at: string;
  updated_at: string;
  title: string;
  description: string;
  theme_obj: ThemeObj;
  registration_page_json_url: string | null;
  registration_page_html_url: string | null;
  is_title_visible: boolean;
  disable_enter_event_button: boolean;
  enable_tech_check: boolean;
  show_onboarding: boolean;
  logo_url: string;
  favicon: string;
  show_discussion_rooms: boolean;
  discussions_chat_disabled: boolean;
  discussion_room_tab_title: string | null;
  show_booths: boolean;
  booth_chat_disabled: boolean;
  booth_tab_title: string | null;
  booth_tab_title_2: string | null;
  show_attendees: boolean;
  p2p_chat_disabled: boolean;
  people_tab_title: string | null;
  speaker_tab_visible: boolean;
  speaker_tab_title: string | null;
  public_chat_disabled: boolean;
  gifs_enabled: boolean;
  is_text_qna_moderated: boolean;
  have_text_qna: boolean;
  have_video_qna: boolean;
  enable_live_captions: boolean;
  enable_live_captions_translations: boolean;
  email_alias_name: string | null;
  created_by: string | null;
  updated_by: string;
  organization: string;
  registration_form: string;
  registration_form_data: FormPublic;
  app_ui_language: string;
  default_language: string;
  event: string | null;
  workspace: WorkspaceBasicInfo;
  integration_template: string | null;
}

export interface EmailTemplate {
  id?: string;
  email_html?: string;
  email_json?: string;
  name?: string;
}

export interface Templates {
  [id: string]: Template;
}

export interface Params {
  searchTerm: string;
  sortBy: SortBy;
  currentPage: number;
}

export const enum SortBy {
  TitleDescending,
  TitleAscending,
  DateDescending,
  DateAscending
}

export const enum FilterBy {
  AllTemplates,
  OrganizationTemplates,
  WorkspaceTemplates
}

export interface TemplateNotification {
  id: string;
  name: string;
  activity_type: EventPingActivityTypeEnum;
  custom_message?: string;
  enabled?: boolean;
  integration: IntegrationEnum;
  notify_to: NotifyTo;
}

export interface TemplateWebhook {
  activity_types: ActivityTypesEnum[];
  enabled?: boolean;
  headers: { [key: string]: any };
  id: string;
  name: string;
  request_type?: RequestTypeEnum;
  url: string;
}
